export default {
  title: 'Astrochingolo',
  subtitle: 'Risk analysis for cities of today and tomorrow',
  riskIndex: '📊 Risk Index',
  mapDescription: 'Interactive map',
  viewMap: '🗺️ View Map'
}
